import { Capacitor } from "@capacitor/core"
import { toast } from "sonner"
import { getAppUrl } from "~/lib/client-url"

export async function shareUrl({
	title,
	text,
	url,
	dialogTitle = "Share"
}: {
	title: string
	text?: string
	url: string
	dialogTitle?: string
}) {
	const shareUrl = getAppUrl(url)

	if (Capacitor.isNativePlatform()) {
		const { Share } = await import("@capacitor/share")
		await Share.share({ title, text, url: shareUrl, dialogTitle })
		return
	}

	await navigator.clipboard.writeText(shareUrl)
	toast("Copied link to clipboard", { description: shareUrl })
}
